<template>
  <div id="audioFileManagerDiv">
    <div v-for="key in idbStore.audioDataTitles" :key="key">
      <button @click="audioRemoveButtonClick(key)">x</button>
      <button @click="audioLoadButtonClick(key)">{{key}}</button>
      
    </div>
  </div>
</template>

<script setup>
import { useAudioStore } from '../../stores/AudioStore';
import { useIDBStore } from '../../stores/IDBStore';

const idbStore = useIDBStore()
const audioStore = useAudioStore()

const audioRemoveButtonClick = (key) => idbStore.removeAudioDataItem(key)
const audioLoadButtonClick = (key) => {
  idbStore.getAudioDataValue(key).then(e => audioStore.loadAudio(e))
}
</script>
